module.exports = __webpack_public_path__ + "static/media/drumnow-2.661e76c5.jpg";